import {Component, forwardRef, Injector, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {AbstractSingleSelectColumnComponent} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-extra-single-select-column",
    templateUrl: "./extra-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => ExtraSingleSelectColumnComponent), multi: true}
    ]
})
export class ExtraSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + ".id";
        this.labelField = this.field + ".name";
    }
}
